import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { InfoButton } from 'components';
import React, { useCallback } from 'react';
import { texts } from 'utils/languages/fr';
import {
    MemoizedCountriesSelect,
    MemoizedRadioGroup,
} from '../memoized-components/MemoizedComponents';

const useStyles = makeStyles(theme => ({
    field: {
        maxWidth: theme.constants.tunnelInputWidth,
        width: '100%',
        '&$fiscalObligationField': {
            marginRight: 10,
        },
    },
    fiscalObligationField: {},
    fiscalObligationLine: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'row',
        [theme.breakpoints.down(600)]: {
            border: `1px solid ${theme.palette.grey['A700']}`,
            padding: 10,
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginBottom: 10,
        },
    },
    infoButton: { marginTop: 10 },
    actionButtons: {
        marginBottom: '16px',
        alignSelf: 'flex-end',
        [theme.breakpoints.down(600)]: {
            alignSelf: 'flex-start',
        },
    },
    label: {
        letterSpacing: 1.6,
        color: 'rgba(0, 0, 0, 0.54)',
    },
}));

const FiscalSituationFormFPCIPM = ({ errors, fiscalSituation, onChange }) => {
    const classes = useStyles();

    const handleChange = useCallback(
        e => {
            const value = e.target.value;
            const name = e.target.name;
            onChange(name, value);
        },
        [onChange]
    );

    if (!fiscalSituation) {
        return null;
    }

    return (
        <React.Fragment>
            <Box display="flex" alignItems="center">
                <Typography className={classes.label}>{texts.COCHER_UNE_DES_DEUX_CASES}</Typography>
                <InfoButton
                    disableMarginBottom
                    content={
                        <React.Fragment>
                            <Typography gutterBottom>
                                Une <i>US person</i> est soit :
                            </Typography>
                            <ul>
                                <li>
                                    <Typography gutterBottom>
                                        {texts.US_PERSON_TEXT_OPT1}
                                    </Typography>
                                </li>
                                <li>
                                    <Typography gutterBottom>
                                        {texts.US_PERSON_TEXT_OPT2}
                                    </Typography>
                                </li>
                            </ul>
                        </React.Fragment>
                    }
                    title={texts.US_PERSON}
                />
            </Box>
            <MemoizedRadioGroup
                name="isUSPerson"
                onChange={handleChange}
                value={fiscalSituation.isUSPerson}
                noValue="eligible"
                yesValue="ineligible"
                noLabel={texts.JE_SUIS_NON_US_PERSON}
                yesLabel={texts.JE_SUIS_US_PERSON}
            />

            <MemoizedCountriesSelect
                name="taxResident"
                inputStyle={classes.field}
                onChange={handleChange}
                value={fiscalSituation.taxResident}
                label={texts.FISCAL_RESIDENCE}
                error={errors.taxResident}
            />
        </React.Fragment>
    );
};

export default FiscalSituationFormFPCIPM;
